<template>
  <v-dialog
    v-model="showModal"
    max-width="900"
  >
    <v-card
      class="base-card"
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon class="icon-style">
          mdi-clipboard-text-clock-outline
        </v-icon>Time Slots List
      </h2>
      <v-container
        id="regular-tables"
        fluid
      >
        <v-card
          shaped
          color="#CFD8DC"
        >
           <v-card-title>
            <v-row>
              <v-col
                cols="12"
                lg="4"
              >
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="advTimeSlotsList"
            class="elevation-1"
            mobile-breakpoint="100"
            :search="search"
            disable-sort
          >
            <template #item="{ item }">
              <tr>
                <td>{{ item.name }}</td>
                <td>
                  {{ item.duration }} Sec
                </td>
                <td>{{ item.pricing_period }}</td>
                <td>
                  {{ item.start | convertStringToLocalDatetime }}
                </td>
                <td>
                  <font
                    class="my-status-style"
                    :color="getColor(item.subscription_status)"
                  >
                    {{ item.subscription_status | statusUpdate }}
                  </font>
                </td>
                <td>
                  {{ item.end | convertStringToLocalDatetime }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="mt-2"
            color="red darken-3"
            @click="showModal = false"
          >
            Close
          </v-btn>
        </v-card-actions>
        <centre-spinner
          :loading="loading"
        />
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import moment from 'moment';

  export default {
    name: 'DigiBoardAdvertiserTimeSlots',
    components: {
      'centre-spinner': spinner,
    },
    filters: {
      convertStringToLocalDatetime (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
      statusUpdate (status) {
        if (status === 'active') {
          return 'Active*';
        } else if (status === 'trial') {
          return 'Trial';
        } else if (status === 'grace_period') {
          return 'Grace Period';
        } else {
          return 'Expired';
        }
      },
    },
    props: {
      advTimeSlotsList: {
        type: Array,
        default: null,
      },
    },
    data () {
      return {
        showModal: true,
        loading: false,
        headers: [
          { text: 'Slot Name', align: 'start', value: 'name' },
          { text: 'Duration', value: 'duration' },
          { text: 'Plan Period', value: 'purchase_status' },
          { text: 'Start', value: 'start' },
          { text: 'Status', value: 'subscription_status' },
          { text: 'Expires At', value: 'end' },
        ],
        search: '',
      };
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    methods: {
      getColor (status) {
        if (status === 'active') return '#2E7D32';
        else if (status === 'expired') return '#C62828';
        else return '#EF6C00';
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 10px;
  margin-bottom: 5px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.v-data-table { background-color: #ECEFF1; }
.my-status-style {
  font-weight: bold;
  font-size: 15px;
}
#regular-tables {
  margin-bottom: 7px;
}
.base-card {
    padding-right: 50px;
    padding-left: 50px;
}
</style>
